// This file defines the routes for the application.
// The default route is set to the rdsap component, which is defined in the rdsap module.

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { RdsapErrorComponent } from '../rdsap/components/error/rdsap-error.component';

const routes: Routes = [
  { path: 'error', component: ErrorPageComponent },
  { path: 'rdsap', component: RdsapErrorComponent},
  { path: '**', redirectTo: '/error', pathMatch: 'full' },
];

// The routes are exported as a module.
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
